module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/wedding_compact-item-option-8c3398382abed80cd7683b589e03bef5.png";